import { createRoute, useNavigate } from '@tanstack/react-router'
import { projectRoute } from '../route'
import { useState } from 'react'
import { ChatInterface } from '@/components/chat-interface'
import { getChatDraftMode, setChatDraft } from '@/lib/chat-draft-store'
import { orpc } from '@/lib/orpc-client'
import type { ChatAttachmentInfo } from '@/lib/collab/use-chat-collab'

export const chatIndexRoute = createRoute({
  getParentRoute: () => projectRoute,
  path: '/chat/',
  component: ChatHome,
})

function ChatHome() {
  const { projectId } = chatIndexRoute.useParams()
  const navigate = useNavigate()
  const [isSending, setIsSending] = useState(false)

  const handleNewChat = async (message: string, attachments?: ChatAttachmentInfo[]) => {
    const initialMode = getChatDraftMode(projectId, 'new') ?? 'normal'
    if (isSending) return
    setIsSending(true)

    try {
      const thread = await orpc.chat.createThread({ projectId, title: message.slice(0, 100) })
      window.dispatchEvent(new CustomEvent('chat-threads-changed'))
      void navigate({
        to: '/$projectId/chat/$chatId',
        params: { projectId, chatId: thread.id },
        state: {
          initialMessage: message,
          initialAttachments: attachments,
          // Mode picked while composing on the landing (its draft is cleared
          // on send, so it must ride along to the new thread's first turn).
          initialMode,
        } as Record<string, unknown>,
      })
    } catch {
      // Thread creation failed — restore the draft so the user doesn't lose
      // what they typed. ChatInput already cleared its own draft on send.
      setChatDraft(projectId, 'new', message)
      setIsSending(false)
    }
  }

  return (
    <ChatInterface
      onNewChat={handleNewChat}
      isSending={isSending}
      draftKey={{ projectId, threadKey: 'new' }}
    />
  )
}
